<div class="changes-card">
  <div class="submission-card-description">{{ label }}</div>
  <ng-content></ng-content>
  <div class="changes-list">
    <div *ngFor="let item of detailsChanges" class="data-field">
      <div class="data-label">{{ item.key }}</div>
      <div
        class="data-value"
        [ngClass]="{
          'new-change': item.hasChanged && changeType === SubmissionDetailsFieldChangeTypeEnum.New,
          'previous-change': item.hasChanged && changeType === SubmissionDetailsFieldChangeTypeEnum.Previous
        }"
        [class.strikethrough]="item.hasChanged && changeType === SubmissionDetailsFieldChangeTypeEnum.Previous">
        {{ item.value }}
      </div>
    </div>
  </div>
</div>
